// package imports
import React, { FC } from 'react';

const TemplateLayout: FC<any> = (props): React.JSX.Element => {
  return <div className="flex template-container">{props.children}</div>;
};

export default TemplateLayout;
